import {
    createContext,
    useContext,
    type ComponentPropsWithRef,
    type ComponentType,
    type ReactNode,
} from 'react';

export type LinkComponentProps = ComponentPropsWithRef<'a'> & { href: string };

export type LinkComponent = ComponentType<LinkComponentProps>;

function NativeLink(props: LinkComponentProps) {
    return <a {...props} />;
}

const LinkContext = createContext<LinkComponent>(NativeLink);

export type LinkProviderProps = {
    component: LinkComponent;
    children: ReactNode;
};

export function LinkProvider({ component, children }: LinkProviderProps) {
    return <LinkContext.Provider value={component}>{children}</LinkContext.Provider>;
}

export function useLinkComponent(): LinkComponent {
    return useContext(LinkContext);
}
